import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './app/page';
import LoginPage from './app/login/page';
import DashboardPage from './app/dashboard/page';
import ClientsPage from './app/clients/page';
import ClientDetailPage from './app/clients/[id]/page';
import NewClientPage from './app/clients/new/page';
import EditClientPage from './app/clients/[id]/edit/page';
import ProjectsPage from './app/projects/page';
import NewProjectPage from './app/projects/new/page';
import ProjectDetailPage from './app/projects/[id]/page';
import TasksPage from './app/tasks/page';
import NewTaskPage from './app/tasks/new/page';
import TaskDetailPage from './app/tasks/[id]/page';
import EditTaskPage from './app/tasks/[id]/edit/page';
import TimeTrackerPage from './app/time-tracker/page';
import FinancesPage from './app/finances/page';
import InvoicesPage from './app/finances/invoices/page';
import NewInvoicePage from './app/finances/invoices/new/page';
import InvoiceDetailPage from './app/finances/invoices/[id]/page';
import EditInvoicePage from './app/finances/invoices/[id]/edit/page';
import ExpensesPage from './app/finances/expenses/page';
import MeetingsPage from './app/meetings/page';
import NewMeetingPage from './app/meetings/new/page';
import MeetingDetailPage from './app/meetings/[id]/page';
import SettingsPage from './app/settings/page';
import ProfileSettingsPage from './app/settings/profile/page';
import PreferencesPage from './app/settings/preferences/page';
import SecurityPage from './app/settings/security/page';
import NotificationsPage from './app/settings/notifications/page';
import BillingPage from './app/settings/billing/page';
import ReportsPage from './app/reports/page';
import SideProjectsPage from './app/side-projects/page';
import IntegrationsPage from './app/integrations/page';
import IntegrationsSettingsPage from './app/settings/integrations/page';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />

      {/* Clients */}
      <Route path="/clients" element={<ClientsPage />} />
      <Route path="/clients/new" element={<NewClientPage />} />
      <Route path="/clients/:id" element={<ClientDetailPage />} />
      <Route path="/clients/:id/edit" element={<EditClientPage />} />

      {/* Projects */}
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/projects/new" element={<NewProjectPage />} />
      <Route path="/projects/:id" element={<ProjectDetailPage />} />

      {/* Tasks */}
      <Route path="/tasks" element={<TasksPage />} />
      <Route path="/tasks/new" element={<NewTaskPage />} />
      <Route path="/tasks/:id" element={<TaskDetailPage />} />
      <Route path="/tasks/:id/edit" element={<EditTaskPage />} />

      {/* Time Tracker */}
      <Route path="/time-tracker" element={<TimeTrackerPage />} />

      {/* Finances */}
      <Route path="/finances" element={<FinancesPage />} />
      <Route path="/finances/invoices" element={<InvoicesPage />} />
      <Route path="/finances/invoices/new" element={<NewInvoicePage />} />
      <Route path="/finances/invoices/:id" element={<InvoiceDetailPage />} />
      <Route path="/finances/invoices/:id/edit" element={<EditInvoicePage />} />
      <Route path="/finances/expenses" element={<ExpensesPage />} />

      {/* Meetings */}
      <Route path="/meetings" element={<MeetingsPage />} />
      <Route path="/meetings/new" element={<NewMeetingPage />} />
      <Route path="/meetings/:id" element={<MeetingDetailPage />} />

      {/* Settings */}
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/profile" element={<ProfileSettingsPage />} />
      <Route path="/settings/integrations" element={<IntegrationsSettingsPage />} />
      <Route path="/settings/preferences" element={<PreferencesPage />} />
      <Route path="/settings/security" element={<SecurityPage />} />
      <Route path="/settings/notifications" element={<NotificationsPage />} />
      <Route path="/settings/billing" element={<BillingPage />} />

      {/* Reports */}
      <Route path="/reports" element={<ReportsPage />} />

      {/* Side Projects */}
      <Route path="/side-projects" element={<SideProjectsPage />} />

      {/* Integrations */}
      <Route path="/integrations" element={<IntegrationsPage />} />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
